import { Settings, SettingsDefaults, type UpdateSettingsBody } from '@deizi/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';

export const settingsKey = ['settings'] as const;

export function useSettings() {
  return useQuery({ queryKey: settingsKey, queryFn: () => api.get('/settings', Settings) });
}

export function useSettingsDefaults() {
  return useQuery({
    queryKey: ['settings', 'defaults'],
    queryFn: () => api.get('/settings/defaults', SettingsDefaults),
    staleTime: Infinity,
  });
}

export function useUpdateSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateSettingsBody) => api.patch('/settings', Settings, body),
    onSuccess: (s) => {
      qc.setQueryData(settingsKey, s);
      void qc.invalidateQueries({ queryKey: ['settings', 'history'] });
      void qc.invalidateQueries({ queryKey: ['setup'] });
    },
  });
}
